import { Flag } from '@utils';
import { Permission } from '@common/utils/admin_permissions';
import { adminLayoutWrap } from '@middlewares';

import { WebhooksPage } from './pages/WebhooksPage';
import { AddWebhookPage } from './pages/AddWebhookPage';
import { EditWebhookPage } from './pages/EditWebhookPage';
import { WebhookHistoryPage } from './pages/WebhookHistoryPage';

export const routes = {
  Webhooks: {
    label: 'Webhooks',
    path: '/webhooks',
    page: adminLayoutWrap({
      children: <WebhooksPage />,
      flag: Flag.OUTBOUND_WEBHOOKS,
      permissions: [Permission.WEBHOOK_READ],
    }),
  },
  AddWebhook: {
    label: 'Add Webhook',
    path: '/webhooks/create',
    page: adminLayoutWrap({
      children: <AddWebhookPage />,
      flag: Flag.OUTBOUND_WEBHOOKS,
      permissions: [Permission.WEBHOOK_WRITE],
    }),
  },
  EditWebhook: {
    label: 'Edit Webhook',
    path: '/webhooks/edit/:id',
    page: adminLayoutWrap({
      children: <EditWebhookPage />,
      flag: Flag.OUTBOUND_WEBHOOKS,
      permissions: [Permission.WEBHOOK_READ],
    }),
  },
  WebhookHistory: {
    label: 'Webhook History',
    path: '/webhooks/history/:id',
    page: adminLayoutWrap({
      children: <WebhookHistoryPage />,
      flag: Flag.OUTBOUND_WEBHOOKS,
      permissions: [Permission.WEBHOOK_READ],
    }),
  },
};
